import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IUniversity } from 'src/app/model/degree/iuniversity';
import { PAGE_NAMES } from 'src/app/service/ansokan-form-builder/application-names';

@Component({
    selector: 'app-examina',
    styleUrls: ['./examina.component.scss'],
    templateUrl: './examina.component.html',
    standalone: false
})
export class ExaminaComponent implements OnInit {

  private static ID = 0;
  private readonly NAMES = PAGE_NAMES.DEGREE.FIRST;

  @Input() public examinaGroup: UntypedFormGroup;
  @Input() public universities: IUniversity[];
  public code: UntypedFormControl;
  public name: UntypedFormControl;
  public year: UntypedFormControl;
  public uniqueId: number;

  constructor() {
    this.uniqueId = ExaminaComponent.ID++;
  }

  public get years(): string[] {
    const currentYear: number = new Date().getFullYear();
    const years: string[] = [];
    for (let i = 0; i < 66; i++) {
      years[i] = `${currentYear - i}`;
    }
    return years;
  }

  public ngOnInit() {
    // Get form controls.
    this.code = this.examinaGroup.get(this.NAMES.INSTITUTION_CODE) as UntypedFormControl;
    this.name = this.examinaGroup.get(this.NAMES.INSTITUTION_NAME) as UntypedFormControl;
    this.year = this.examinaGroup.get(this.NAMES.YEAR) as UntypedFormControl;
    // Create value change subscriptions.
    this.code.valueChanges.subscribe((value) => this.setName(value, this.universities));
    this.year.valueChanges.subscribe(() => this.examinaGroup.updateValueAndValidity());
  }

  public setName(code: string, universities: IUniversity[]): void {
    const university = universities.find((i) => i.code === code);
    this.name.setValue(university ? university.name : '');
  }

}
